import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { BulkEmailInput } from '@/models/email';

export const sendBulkEmailByEmailAddresses = async ({
  from,
  subject,
  body,
  purpose,
  list,
  delayBetweenSendingEachEmail,
}: BulkEmailInput) => {
  const response = await mutationExecute({
    variables: {
      from,
      subject,
      body,
      purpose,
      list,
      delayBetweenSendingEachEmail,
    },
    mutation: graphql(`
      mutation SendBulkEmailByEmailAddresses(
        $from: String!
        $subject: String!
        $body: String!
        $purpose: String!
        $list: [String!]!
        $delayBetweenSendingEachEmail: Float!
      ) {
        sendBulkEmailByEmailAddresses(
          from: $from
          subject: $subject
          body: $body
          purpose: $purpose
          list: $list
          delayBetweenSendingEachEmail: $delayBetweenSendingEachEmail
        ) {
          success
          receiverCount
          warnings {
            nonCallerEmailAddresses
            callerIdsWithoutEmailAddress
          }
        }
      }
    `),
  });

  return response.data?.sendBulkEmailByEmailAddresses;
};
